import { useQuery } from "@tanstack/react-query";
import type { FC } from "react";
import React, { useState } from "react";

import { FolderTree as BaseFolderTree } from "@react/domains/taxonomy";

import type { FolderTreeNode } from "@apis/taxonomy/api";
import type { TaxonomyId } from "@apis/taxonomy/models";

import { useQueries } from "../../../shared/hooks/useQueries.ts";

interface FolderTreeProps {
  readonly taxonomyId: TaxonomyId;
}

export const FolderTree: FC<FolderTreeProps> = ({ taxonomyId }) => {
  const { getTaxonomyFolderTreeQueryOptions } = useQueries();
  const folderTree = useQuery(
    getTaxonomyFolderTreeQueryOptions({ taxonomyId }),
  );

  const [selected, setSelected] = useState<FolderTreeNode | null>(null);

  return (
    <div className="flex flex-col gap-4">
      <BaseFolderTree
        error={folderTree.error}
        folders={folderTree.data?.folderTree.folders ?? []}
        isPending={folderTree.isPending}
        onSelect={setSelected}
        selected={selected}
      />
      {selected && (
        <pre className="overflow-x-auto rounded-md border p-3 font-mono text-sm">
          {JSON.stringify(selected.filter, null, 2)}
        </pre>
      )}
    </div>
  );
};
